<div class="page-header">
    <div class="header-details">
        <div class="header-title">
            <h1>{{label() | translate}}</h1>
            <lokos-breadcrumb [breadcrumbs]='breadcrumbs()' />
        </div>
        <div class="header-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>